import { FORTA_BLACK } from '../../../../utils/colors';

import type { ReactNode } from 'react';

type TimeScaleAxisProps = {
  timeScale: string[];
  children: ReactNode;
};

const TimeScaleAxisLine = ({
  timeScale,
  flipOrder = false,
}: {
  timeScale: string[];
  flipOrder?: boolean;
}) => (
  <div style={{ position: 'relative', height: 32, marginTop: 2, marginBottom: 8, marginLeft: 95 }}>
    <div
      style={{
        position: 'absolute',
        top: 16,
        left: 0,
        right: 0,
        height: 1,
        background: FORTA_BLACK,
        borderRadius: 1,
      }}
    />
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: 32,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      {timeScale.map((label, idx) => (
        <div
          key={idx}
          style={{
            textAlign: 'center',
            fontSize: 12,
            color: '#333',
            minWidth: 60,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: 1,
              height: 8,
              background: FORTA_BLACK,
              borderRadius: 1,
              marginBottom: flipOrder ? 6 : 0,
              marginTop: !flipOrder ? 8 : 0,
            }}
          />
          {<div style={{ height: flipOrder ? 0 : 36 }}>{label}</div>}
        </div>
      ))}
    </div>
  </div>
);

const TimeScaleAxis = ({ timeScale, children }: TimeScaleAxisProps) => (
  <>
    <TimeScaleAxisLine timeScale={timeScale} flipOrder={false} />
    {children}
    <TimeScaleAxisLine timeScale={timeScale} flipOrder={true} />
  </>
);

export default TimeScaleAxis;
